
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import CategoryAddEdit from './CategoryAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class MenuVariantCategory {
  id: string = '';
  name: string = '';
}

@Component({
  components: {
    editor: CategoryAddEdit
  }
})
export default class MenuVariantsCategory extends RemoteDataTable<
  MenuVariantCategory
  > {
  public pageTitle: string = 'Menu Variant Category';

  public newButtonText: string = 'New Variant Category';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'name', label: 'Name', sortable: false })
  ];

  // to get page data
  get items(): MenuVariantCategory[] {
    return this.$store.getters.GetAllVariantCategory;
  }

  get paging(): MenuVariantCategory[] {
    return this.$store.getters.PagingVariantCategory;
  }

  get sorting(): MenuVariantCategory[] {
    return this.$store.getters.SortingMenuItem;
  }

  get filtering(): MenuVariantCategory[] {
    return this.$store.getters.FilteringVariantCategory;
  }
  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringCategoryItem', {
      isResetFilter: isResetFilter
    });
  }
  mounted() {
    this.$store.commit('SET_FILTERING_CATEGORY', '');
  }
  reload(id = null) {
    this.$store.dispatch('GetAllCategoryItem');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteCategoryItem', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, 'Category is deleted');
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.menuvariant.pagingVariantCategory.size = page;
    this.$store.dispatch('GetAllCategoryItem');
  }
  sortingChanged(ctx) {}
}
